import React, { useState, useEffect } from 'react'
import { FAIcon } from './FAIcon'
import { FormBox } from './FormBox'
import { ActionLink } from './ActionLink'
import { Grid } from './Grid'
import { GridCell } from './GridCell'
import { RadioListBox } from './RadioListBox'
import styles from './DataGridFilter.less'
import { ah, ReduxWrapper, compose } from 'common-data/datahelpers'
import _ from 'common-tools/LodashHelper'
import { componentGetCompareProps, IdHelper, getArrayChanges } from 'common-tools/index'
import { FieldValueConverters } from './FieldValueConverters'
import { Field } from 'redux-form'
import TagsInput from 'react-tagsinput'
import clsx from 'clsx'

function DataGridFilterSearchBox (props) {
  const { input = {} } = props
  const { value, onChange } = input

  const [tag, setTag] = useState('')

  function handleChangeInput (tag) {
    setTag(tag)
  }

  return <TagsInput
    value={value || []}
    onChange={onChange}
    inputValue={tag}
    className={styles.searchBox}
    onChangeInput={handleChangeInput}
    inputProps={{
      placeholder: value.length > 0 ? '' : 'Search',
      className: styles.searchBoxInput
    }}
    tagProps={{
      className: 'label'
    }}
  />
}

export function DataGridFilterBox (props) {
  const { title, message, children, isActive, notCustom } = props

  const [controls, setControls] = useState([])

  useEffect(() => {
    if (_.isArray(children)) {
      setControls(_.map(children, (c) => {
        if (notCustom) {
          return React.cloneElement(c, { namePrefix: 'Filters' })
        } else {
          return c
        }
      }))
    } else {
      setControls([
        notCustom ? children : React.cloneElement(children, { namePrefix: 'Filters' })
      ])
    }
  }, [children])

  return <GridCell>
    <div className={styles.cellBg}>
      <div className={styles.filterFormBox}>
        {isActive
          ? <><FAIcon name='check-square' className={styles.filterActive} />&nbsp; <strong>{title}</strong><span>{message}</span></>
          : <><strong>{title}</strong><span>{message}</span></>
        }
        <hr />
        {controls}
      </div>
    </div>
  </GridCell>
}

export const DataGridFilter = compose(
  ReduxWrapper([
  ], [
    ah.formSetFieldValue,
    ah.formResetValues
  ])
)(function DataGridFilterPlain (props) {
  const { formValues, formName, loading, children, displayFilter, initialValues = {}, sortOptions, readonly, alwaysSendFilterPropNames = [], onSubmit, formResetValues, extraicons = [], bufferLarge } = props

  const [filterOpen, setFilterOpen] = useState(false)
  const [hasSearchText, setHasSearchText] = useState(false)

  function handleSubmit (values) {
    const postData = _.omit(values, 'Filters')

    const newFilters = []

    if (_.has(initialValues, 'Filters') & _.has(values, 'Filters')) {
      // build filters based on inital values
      postData.Filters = {}
      const filterKeys = _.keys(initialValues.Filters)

      for (var filterKey of filterKeys) {
        // if the key matches the always send list, don't try to filter out
        // default values

        if (_.isArray(initialValues.Filters[filterKey])) {
          const filterKeyArrayCompare = componentGetCompareProps(filterKey, values.Filters, initialValues.Filters, [])
          if (filterKeyArrayCompare.Current.length === filterKeyArrayCompare.Previous.length) {
            const currentValues = _.map(filterKeyArrayCompare.Current, 'Value')
            const previousValues = _.map(filterKeyArrayCompare.Previous, 'Value')
            const diffs = _.difference(currentValues, previousValues)
            if (diffs.length > 0) {
              if (currentValues.length > 0) {
                postData.Filters[filterKey] = filterKeyArrayCompare.Current
              }
              newFilters.push(filterKey)
            } else {
              if (_.indexOf(alwaysSendFilterPropNames || [], filterKey) !== -1) {
                if (currentValues.length > 0) {
                  postData.Filters[filterKey] = filterKeyArrayCompare.Current
                }
              }
            }
          } else {
            if (filterKeyArrayCompare.Current.length > 0) {
              postData.Filters[filterKey] = filterKeyArrayCompare.Current
            }
            newFilters.push(filterKey)
            if (_.indexOf(alwaysSendFilterPropNames || [], filterKey) !== -1) {
              if (filterKeyArrayCompare.Current.length > 0) {
                postData.Filters[filterKey] = filterKeyArrayCompare.Current
              }
            }
          }
        } else {
          const filterKeyCompare = componentGetCompareProps(filterKey, values.Filters, initialValues.Filters, {})
          if (filterKeyCompare.Current.Value !== filterKeyCompare.Previous.Value) {
            postData.Filters[filterKey] = filterKeyCompare.Current
            newFilters.push(filterKey)
          } else {
            if (_.indexOf(alwaysSendFilterPropNames || [], filterKey) !== -1) {
              postData.Filters[filterKey] = filterKeyCompare.Current
            }
          }
        }
      }
    }

    setHasSearchText(postData.FilterText?.length > 0)

    if (_.isFunction(onSubmit)) {
      onSubmit(postData)
    }
  }

  function handleFilterButtonClick (e) {
    setFilterOpen(!filterOpen)
  }

  function handleResetButtonClick (e) {
    formResetValues(formName)
  }

  const displayFilterprop = typeof displayFilter === 'undefined'
  const [filterBoxes, setFilterBoxes] = useState({ boxes: [], showReset: false })
  const [showFilters, setShowFilters] = useState(!!displayFilterprop)

  useEffect(() => {
    const ret = {
      boxes: [],
      showReset: false
    }

    let items = []

    if (_.isArray(children)) {
      items = _.concat([], children)
    } else if (children) {
      items.push(children)
    }

    if (_.isArray(sortOptions) && initialValues.Sort) {
      if (sortOptions.length > 0) {
        items.push(<DataGridFilterBox key='Sort' title='Sort' message='How to sort the results.' notCustom>
          <RadioListBox options={sortOptions} name='Sort'/>
        </DataGridFilterBox>)
      }
    }

    if (initialValues.Limit < 101) {
      items.push(<DataGridFilterBox key='Limit' title='Limit' message='How many items to show initially.  Clicking the load more will fetch this many more items each time.' notCustom>
        <RadioListBox inline options={[{ Value: 10 }, { Value: 25 }, { Value: 50 }, { Value: 100 }]} fieldType={FieldValueConverters.Int} name='Limit' />
      </DataGridFilterBox>)
    }

    let nonDefaultFields = []

    for (var item of items) {
      if (!item && !React.isValidElement(item)) {
        continue
      }

      const currentValue = _.get(formValues, (item.key === 'Sort' || item.key === 'Limit') ? item.key : `Filters.${item.key}`)
      const initialValue = _.get(initialValues, (item.key === 'Sort' || item.key === 'Limit') ? item.key : `Filters.${item.key}`)

      if (currentValue) {
        if (_.isArray(currentValue)) {
          if (currentValue.length !== initialValue.length) {
            nonDefaultFields.push(item.key)
          } else {
            const current = _.map(currentValue, (v) => (v.Value))
            const initial = _.map(initialValue, (v) => (v.Value))
            const changes = getArrayChanges(current, initial)
            if (changes.hasChanged) {
              nonDefaultFields.push(item.key)
            }
          }
        } else if (_.has(currentValue, 'Value')) {
          if (!_.isEqual(currentValue?.Value, initialValue?.Value)) {
            nonDefaultFields.push(item.key)
          }
        } else {
          if (!_.isEqual(currentValue, initialValue)) {
            nonDefaultFields.push(item.key)
          }
        }
      }
    }

    ret.boxes = _.map(items, (i) => {
      if (_.includes(nonDefaultFields, i.key)) {
        return React.cloneElement(i, { isActive: true })
      } else {
        return React.cloneElement(i, { isActive: false })
      }
    })
    ret.showReset = nonDefaultFields.length > 0
    setFilterBoxes(ret)
    setShowFilters(displayFilterprop ? ret.boxes.length > 0 : displayFilterprop)
  }, [children, sortOptions, initialValues, formValues])

  const [filterIcons, setFilterIcons] = useState([])

  useEffect(() => {
    const icons = _.map(extraicons, (ei) => {
      return <FAIcon key={ei.id || ei.icon || IdHelper.shortId() } name={ei.icon || 'question'} className={ei.active ? 'active' : ''} onClick={ei.onClick} toolTip={ei.toolTip} />
    })
    setFilterIcons(icons)
  }, [extraicons])

  return <FormBox className={bufferLarge ? styles.formBoxBufferLarge : styles.formBoxBuffer} form={formName} initialValues={initialValues} readonly={readonly} loading={loading} onSubmit={handleSubmit} onChange={handleSubmit} simpleBody>
    <Grid paddingX>
      <GridCell small={12}>
        <div className={styles.filterBar}>
          <Grid className='align-middle'>
            <GridCell medium={2}>
              {showFilters
                ? <>
                    <ActionLink onClick={handleFilterButtonClick} className={clsx(styles.filterButton, 'tiny', 'button', 'secondary', filterOpen && 'hollow')}>{filterOpen ? 'Hide' : ''} Filters</ActionLink> <span className={clsx(filterBoxes.showReset || hasSearchText ? 'show-inline' : 'hide', 'tiny')} id="reset">
                      <ActionLink onClick={handleResetButtonClick} className={clsx(styles.filterButton, 'tiny', 'button', 'secondary', 'hollow')}>Reset</ActionLink></span>
                  </>
                : null
              }
            </GridCell>
            <GridCell medium={8}>
              <Field name='FilterText' component={DataGridFilterSearchBox} />
            </GridCell>
            <GridCell medium={2} className='text-right'>
              {filterIcons}
            </GridCell>
          </Grid>
        </div>
      </GridCell>
    </Grid>
    <Grid hide={!showFilters} paddingX className={filterOpen ? '' : 'hide'}>
      <GridCell small={12}>
        <div className={styles.filterInnerBox}>
          <Grid paddingX smallUp={1} mediumUp={2} largeUp={4}>
            {filterBoxes.boxes}
          </Grid>
        </div>
      </GridCell>
    </Grid>

  </FormBox>
})

// export class DataGridFilterPlain2 extends React.Component {
//   constructor (props) {
//     super(props)

//     const { defaultItemKey } = props
//     this.state = {
//       activeTab: defaultItemKey,
//       changedFilters: []
//     }
//   }

//   static propTypes = {
//     formName: pt.string.isRequired,
//     onSubmit: pt.func.isRequired,
//     icon: pt.string.isRequired,
//     loading: pt.bool.isRequired,
//     children: pt.oneOfType([pt.arrayOf(pt.element), pt.element]),
//     hide: pt.bool.isRequired,
//     hideNoStyle: pt.bool.isRequired,
//     readonly: pt.bool,
//     classNames: pt.shape({
//       filter: pt.string,
//       filterTabs: pt.string,
//       filterTabContent: pt.string,
//       filterIcon: pt.string
//     }),
//     sortOptions: pt.arrayOf(pt.shape({
//       Text: pt.string,
//       Value: pt.any
//     })),
//     initialValues: pt.shape({
//       Limit: pt.oneOfType([pt.number, pt.string]).isRequired,
//       Sort: pt.string
//     }),
//     extraicons: pt.arrayOf(pt.shape({
//       icon: pt.string,
//       onClick: pt.func,
//       active: pt.bool,
//       toolTip: pt.string
//     })),
//     alwaysSendFilterPropNames: pt.arrayOf(pt.string)
//   }

//   static defaultProps = {
//     hide: false,
//     hideNoStyle: false,
//     loading: false,
//     icon: 'filter',
//     classNames: {},
//     sortOptions: [],
//     readonly: false,
//     defaultItemKey: null,
//     initialValues: {
//       Limit: 0,
//       Sort: ''
//     },
//     alwaysSendFilterPropNames: []
//   }

//   toggle (tab) {
//     if (this.state.activeTab !== tab) {
//       this.setState({
//         activeTab: tab
//       })
//     } else {
//       this.setState({
//         activeTab: null
//       })
//     }
//   }

//   onSubmit (values) {
//     const { onSubmit, initialValues = {}, alwaysSendFilterPropNames = [] } = this.props
//     const postData = _.omit(values, 'Filters')

//     const changedFilters = []

//     if (_.has(initialValues, 'Filters') & _.has(values, 'Filters')) {
//       // build filters based on inital values
//       postData.Filters = {}
//       const filterKeys = _.keys(initialValues.Filters)

//       for (var filterKey of filterKeys) {
//         // if the key matches the always send list, don't try to filter out
//         // default values

//         if (_.isArray(initialValues.Filters[filterKey])) {
//           const filterKeyArrayCompare = componentGetCompareProps(filterKey, values.Filters, initialValues.Filters, [])
//           if (filterKeyArrayCompare.Current.length === filterKeyArrayCompare.Previous.length) {
//             const currentValues = _.map(filterKeyArrayCompare.Current, 'Value')
//             const previousValues = _.map(filterKeyArrayCompare.Previous, 'Value')
//             const diffs = _.difference(currentValues, previousValues)
//             if (diffs.length > 0) {
//               if (currentValues.length > 0) {
//                 postData.Filters[filterKey] = filterKeyArrayCompare.Current
//               }
//               changedFilters.push(filterKey)
//             } else {
//               if (_.indexOf(alwaysSendFilterPropNames || [], filterKey) !== -1) {
//                 if (currentValues.length > 0) {
//                   postData.Filters[filterKey] = filterKeyArrayCompare.Current
//                 }
//               }
//             }
//           } else {
//             if (filterKeyArrayCompare.Current.length > 0) {
//               postData.Filters[filterKey] = filterKeyArrayCompare.Current
//             }
//             changedFilters.push(filterKey)
//             if (_.indexOf(alwaysSendFilterPropNames || [], filterKey) !== -1) {
//               if (filterKeyArrayCompare.Current.length > 0) {
//                 postData.Filters[filterKey] = filterKeyArrayCompare.Current
//               }
//             }
//           }
//         } else {
//           const filterKeyCompare = componentGetCompareProps(filterKey, values.Filters, initialValues.Filters, {})
//           if (filterKeyCompare.Current.Value !== filterKeyCompare.Previous.Value) {
//             postData.Filters[filterKey] = filterKeyCompare.Current
//             changedFilters.push(filterKey)
//           } else {
//             if (_.indexOf(alwaysSendFilterPropNames || [], filterKey) !== -1) {
//               postData.Filters[filterKey] = filterKeyCompare.Current
//             }
//           }
//         }
//       }
//     }

//     this.setState({
//       changedFilters: changedFilters
//     }, () => {
//       if (_.isFunction(onSubmit)) {
//         onSubmit(postData)
//       }
//     })
//   }

//   reset () {
//     const { formResetValues, formName } = this.props
//     formResetValues(formName)
//     this.setState({
//       activeTab: null
//     })
//   }

//   findFieldNames (children, nameList = []) {
//     React.Children.forEach(children, (child) => {
//       if (!React.isValidElement(child)) {
//         return
//       }

//       if (child.props.name) {
//         nameList.push(child.props.name)
//         if (_.isArray(child.props.children)) {
//           this.findFieldNames(child.props.children, nameList)
//         }
//       }
//     })

//     return nameList
//   }

//   getItems (children, sortOptions, currentValues, initialValues, changedFilters) {
//     const ret = {
//       navs: [],
//       tabs: [],
//       showReset: {}
//     }

//     let items = []

//     if (_.isArray(children)) {
//       items = _.concat([], children)
//     } else {
//       items.push(children)
//     }

//     if (_.isArray(sortOptions) && initialValues.Sort) {
//       if (sortOptions.length > 0) {
//         items.push(<TabBoxItem key='sort' title='Sort'>
//           <RadioListBox options={sortOptions} name='Sort' label='How to sort the results.' />
//         </TabBoxItem>)
//       }
//     }

//     if (initialValues.Limit < 101) {
//       items.push(<TabBoxItem key='limit' title='Limit'>
//         <RadioListBox options={[{ Value: 10 }, { Value: 25 }, { Value: 50 }, { Value: 100 }]} fieldType={FieldValueConverters.Int} name='Limit' label='How many items to show initially.  Clicking the load more will fetch this many more items each time.' />
//       </TabBoxItem>)
//     }

//     const { activeTab } = this.state

//     for (var item of items) {
//       if (!React.isValidElement(item)) {
//         continue
//       }

//       let nonDefaultFields = []

//       if (item.key === 'sort') {
//         if (currentValues.Sort) {
//           if (currentValues.Sort !== initialValues.Sort) {
//             nonDefaultFields.push('Sort')
//           }
//         }
//       } else if (item.key === 'limit') {
//         if (currentValues.Limit) {
//           if (currentValues.Limit !== initialValues.Limit) {
//             nonDefaultFields.push('Limit')
//           }
//         }
//       } else {
//         let fieldNames = this.findFieldNames(item.props.children)

//         fieldNames = _.uniq(fieldNames)

//         let matches = _.intersection(changedFilters, fieldNames)

//         if (matches.length > 0) {
//           nonDefaultFields.push(...matches)
//         }
//       }

//       ret.showReset[item.key] = nonDefaultFields.length > 0

//       ret.navs.push(<NavItem key={item.key}>
//         <div>
//           <NavLink
//             className={activeTab === item.key ? 'active' : ''}
//             onClick={this.toggle.bind(this, item.key)}
//           >
//             {item.props.title}
//           </NavLink>
//           {nonDefaultFields.length > 0
//             ? <Badge color="purple"><FAIcon name='check' size='10px' /></Badge>
//             : null}
//         </div>
//       </NavItem>)
//       ret.tabs.push(<TabPane tabId={item.key} className={styles.filterTabContent}>
//         {item.key === 'sort' || item.key === 'limit'
//           ? item.props.children
//           : <FormSection name='Filters'>
//             {item.props.children}
//           </FormSection>
//         }
//       </TabPane>)
//     }

//     ret.showReset.All = _.find(_.values(ret.showReset), (v) => { return v === true }) > -1

//     return ret
//   }

//   renderEmpty () {
//     const { formName, onSubmit, loading, initialValues, hideNoStyle } = this.props

//     return (
//       <FormBox form={formName} className={hideNoStyle ? '' : styles.nofilter} initialValues={initialValues} loading={loading} onSubmit={onSubmit} onChange={onSubmit} simpleBody>
//       </FormBox>
//     )
//   }

//   renderFull () {
//     const { formValues, formName, icon, loading, classNames, children, initialValues, sortOptions, extraicons, readonly } = this.props
//     const { changedFilters, activeTab } = this.state

//     const items = this.getItems(children, sortOptions, formValues, initialValues, changedFilters)

//     return (
//       <FormBox className={classNames.filter || styles.filter} form={formName} initialValues={initialValues} readonly={readonly} loading={loading} onSubmit={this.onSubmit.bind(this)} onChange={this.onSubmit.bind(this)} simpleBody>
//         <div className={classNames.filterIcon || styles.filterIcon}>
//           {items.navs.length > 0
//             ? <FAIcon name={icon || 'filter'} className={items.showReset.All ? 'active' : ''} onClick={items.showReset.All ? this.reset.bind(this) : null} toolTip={items.showReset.All ? 'Reset' : null} />
//             : null
//           }
//         </div>
//         <div className={classNames.filterTabs || styles.filterTabs}>
//           <Nav tabs>
//             {items.navs}
//           </Nav>
//         </div>
//         <div className={classNames.extraIcons || styles.extraIcons}>
//           {_.map(extraicons, (ei) => {
//             return <FAIcon key={ei.id || ei.icon || IdHelper.shortId() } name={ei.icon || 'question'} className={ei.active ? 'active' : ''} onClick={ei.onClick} toolTip={ei.toolTip} />
//           })}
//         </div>
//         <TabContent animate={activeTab !== null ? 'open' : 'closed'} initial='start' key='tabbox' activeTab={this.state.activeTab} className={`${styles.filterTabList} fancyscroll ${activeTab !== null ? styles.filterTabListOpened : ''}`}>
//           {items.tabs}
//         </TabContent>
//       </FormBox>
//     )
//   }

//   render () {
//     const { hide } = this.props

//     if (hide === true) {
//       return this.renderEmpty()
//     } else {
//       return this.renderFull()
//     }
//   }
// }

export default DataGridFilter
